/**
 * Socket.IO client singleton.
 *
 * ПРИНЦИП: Socket.IO = lightweight "invalidate" сигнал.
 *   • При "quests:invalidate" клієнт робить звичайний HTTP-запит щоб оновити квести.
 *   • Сокет НЕ несе повного payload квестів.
 */
import { io, type Socket } from "socket.io-client";

const getSocketUrl = (): string => {
  const origin = window.location.origin;
  // В dev-режимі проксі через vite (/api → backend), для сокету теж беремо бекенд
  if (origin.includes("localhost") || origin.includes("ngrok-free.app")) {
    return origin; // socket.io підключиться до того ж origin, vite проксіює
  }
  return "https://notapi.web3islands.com";
};

const getAuthPayload = (): Record<string, string> => {
  const tg: { initData?: string } | undefined = window.Telegram?.WebApp;
  const initData = tg?.initData || "";

  // Для тестового режиму підтримуємо той самий механізм, що й HTTP
  const testUserId = localStorage.getItem("test_user_id") || undefined;
  const botToken = localStorage.getItem("bot_token") || undefined;

  if (testUserId) {
    return { testUserId, testBotToken: botToken || "" };
  }

  return { initData };
};

let _socket: Socket | null = null;

export function getSocket(): Socket {
  if (!_socket) {
    const url  = getSocketUrl();
    const auth = getAuthPayload();
    _socket = io(url, {
      path: "/socket.io",
      auth,
      transports: ["websocket", "polling"],
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      autoConnect: false, // manually connect after app is ready
    });

    _socket.on("connect_error", (e) => console.error("[SOCKET] connect_error", e.message, e));
  }
  return _socket;
}

export function connectSocket(): void {
  const socket = getSocket();
  if (!socket.connected) {
    socket.connect();
  }
}

export function disconnectSocket(): void {
  if (_socket) {
    _socket.disconnect();
  }
}
